/* eslint-disable @typescript-eslint/camelcase */
export const ar = { translation: require('./ar.json') };
export const bg = { translation: require('./bg.json') };
export const ca = { translation: require('./ca.json') };
export const cs = { translation: require('./cs.json') };
export const da = { translation: require('./da.json') };
export const de = { translation: require('./de.json') };
export const el = { translation: require('./el.json') };
export const en = { translation: require('./en.json') };
export const es = { translation: require('./es.json') };
export const et = { translation: require('./et.json') };
export const fi = { translation: require('./fi.json') };
export const fr = { translation: require('./fr.json') };
export const he = { translation: require('./he.json') };
export const hi = { translation: require('./hi.json') };
export const hr = { translation: require('./hr.json') };
export const hu = { translation: require('./hu.json') };
export const id = { translation: require('./id.json') };
export const it = { translation: require('./it.json') };
export const ja = { translation: require('./ja.json') };
export const ko = { translation: require('./ko.json') };
export const lt = { translation: require('./lt.json') };
export const lv = { translation: require('./lv.json') };
export const nb = { translation: require('./nb.json') };
export const nl = { translation: require('./nl.json') };
export const pl = { translation: require('./pl.json') };
export const pt = { translation: require('./pt.json') };
export const ro = { translation: require('./ro.json') };
export const ru = { translation: require('./ru.json') };
export const sk = { translation: require('./sk.json') };
export const sl = { translation: require('./sl.json') };
export const sr = { translation: require('./sr.json') };
export const sv = { translation: require('./sv.json') };
export const tr = { translation: require('./tr.json') };
export const uk = { translation: require('./uk.json') };
export const zh = { translation: require('./zh.json') };
